import styled from 'styled-components'

export const AboutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-width: 1170px;

  padding: 0 16px;
  margin: 100px 0;

  .about {
    color: ${({ theme }) => theme.colors.darkgray};

    white-space: pre-wrap;
    font-weight: ${({ theme }) => theme.fontWeights.light};

    line-height: ${({ theme }) => theme.lineHeight.b3};
    font-size: ${({ theme }) => theme.fontSizes.b3};

    @media (max-width: 791px) {
      line-height: ${({ theme }) => theme.lineHeight.b4};
      font-size: ${({ theme }) => theme.fontSizes.b4};
    }
  }
`
